
import React, { useEffect } from 'react';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';

import OperationStatus from '../common/client/components/OperationStatus';
import Routes from '../common/client/components/Routes';

import usePageTracking from './usePageTracking';

initializeIcons();

const App = (props) => {

    useEffect(() => {
        // nop;
    }, []);

    usePageTracking();

    return (
        <>
            <Routes routes={props.routes} />
            <OperationStatus />
        </>
    );
};

export default App;
